export default __webpack_public_path__ + "240e057b09b74a56018db6388aa98e48.png";